import { Stack } from "@mui/material"
import { ReactElement } from "react"

import AppSkeleton from "./appSkeleton"
import FullScreenTitleContent from "../../account/common/fullScreenTitleContent"
import ConnectDirectLogo from "../../logos/logos"

/** Displayed when account set up dialog is open and API is checking if there
 * is a pending invite
 */
const FirstLoginSkeleton = (): ReactElement => (
    <FullScreenTitleContent
        customSvg={<ConnectDirectLogo fontSize="500px" />}
        titlePrimaryColor=""
        titleMain=""
        subtitle=""
        content={
            <Stack
                direction="column"
                alignItems="center"
                width="100%"
                height="100%"
                spacing={6}
            >
                <Stack spacing={1} width="100%" alignItems="center">
                    <AppSkeleton
                        height={50}
                        width="90%"
                        aria-label="first log in skeleton"
                    />
                </Stack>
                <Stack spacing={1} width="100%" alignItems="center">
                    <AppSkeleton height={20} width="100%" />
                </Stack>
                <Stack
                    flexGrow={1}
                    width="100%"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Stack spacing={1} width="100%" alignItems="center">
                        <AppSkeleton height={75} width="90%" />
                        <AppSkeleton height={75} width="90%" />
                        <AppSkeleton height={75} width="90%" />
                        <AppSkeleton height={75} width="90%" />
                    </Stack>
                    <AppSkeleton height={20} width="50%" />
                </Stack>
            </Stack>
        }
    />
)

export default FirstLoginSkeleton
